export default "__VITE_ASSET__4_YCc15a__"